/** Campos enviados em PATCH /nsmps/{id}/digitacao-uso-mutuo */
const pickSubNsmpDigitacao = (sub) => {
  if (!sub?.id) return null;
  const item = { id: sub.id };
  if (sub.observacaoDigitador !== undefined) {
    item.observacaoDigitador = sub.observacaoDigitador;
  }
  if (sub.validate !== undefined) {
    item.validate = sub.validate;
  }
  return item;
};

export const pickDigitacaoUsoMutuoPayload = (values) => {
  const payload = { id: values.id };
  if (values.observacaoDigitador !== undefined) {
    payload.observacaoDigitador = values.observacaoDigitador;
  }
  payload.subNsmps = (values.subNsmps || [])
    .map(pickSubNsmpDigitacao)
    .filter(Boolean);
  return payload;
};

export default pickDigitacaoUsoMutuoPayload;
